import {Gender} from "../enums/Gender";
import {RoleDto} from "./RoleDto";
import {UserStatus} from "../enums/UserStatus";
import {DepartmentDto} from "./DepartmentDto";

export class UserDto {
    keyId: string = '';
    id: string = '';
    supervisorId: string = '';
    departmentId: string = '';
    uid: string = '';
    email: string = '';
    mobile: string = '';
    password: string = '';
    passwordModifyTime: string = '';
    oldPassword: string = '';
    status: string = UserStatus.Enum.Active;
    fullName: string = '';
    lastName: string = '';
    firstName: string = '';
    nickname: string = '';
    gender: string = Gender.Enum.None;
    birthday: string = '';
    portrait: string = '';
    lastLoginTime: string = '';
    roles: Array<RoleDto> = [];
    dataGroupId: string = '';
    wxOpenId: string = "";
    department?:DepartmentDto;
}
